module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "figcenter1"
  }, [_c('a', {
    attrs: {
      "id": "i_frontis"
    }
  }, [_c('img', {
    staticClass: "calibre10",
    attrs: {
      "alt": "",
      "id": "id-6085934664019861818",
      "src": "Images/img0006.jpg",
      "title": ""
    }
  })]), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0008#Page_36"
    }
  }, [_vm._v("“WE TAUGHT THOSE THAR RED DEMONS A LESSON THEY’LL NOT FORGET.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00001",
      "title": "[5]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_5",
      "title": "[5]"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0